<template>
  <header class="header">
    <div class="top wrapper">
      <div class="left">
        <router-link to="/" class="logo">
          <img src="./../images/logo.svg" class="img" />
        </router-link>
      </div>
      <div class="center">
        <ul class="nav">
          <template v-for="item in $parent.headerNav">
            <li class="nav__item" :key="item.title">
              <router-link class="" :to="item.path">
                {{ item.title }}
              </router-link>
            </li>
          </template>
          <li v-if="aboutUs" class="nav__item">
            <router-link
              class=""
              :to="aboutUs.slug
                ? { name: 'StaticPageBySlug', params: { slug: aboutUs.slug } }
                : { name: 'TextPage', params: { id: aboutUs.id } }"
            >
              About Us
            </router-link>
          </li>
        </ul>
      </div>
      <div class="right">
        <template v-if="!$parent.isAuth">
          <button @click="$parent.openRegister()" class="button white">
            Sign up
          </button>
          <button @click="$parent.openSignInModal()" class="button">
            Login
          </button>
        </template>
        <router-link tag="button" to="/profile" v-else class="button">
          My profile
        </router-link>

        <!--        <div v-if="!$parent.isAuth" class="user hover-link" @click="$parent.openSignInModal">-->
        <!--          <img src="./../images/user.svg" class="img"/>-->
        <!--        </div>-->
        <!--        <router-link v-if="$parent.isAuth" class="user hover-link" to="/profile">-->
        <!--          <img src="./../images/user.svg" class="img"/>-->
        <!--        </router-link>-->
      </div>
    </div>

    <div v-if="$route.name === 'Home'" class="content">
      <img class="figure" src="../images/figure_1.svg" alt="" />
      <div class="content__wrapper">
        <h2 class="title">
          No Limits. Just Possibilities. Welcome to Your Crypto Exchange.
        </h2>
        <h5 class="subtitle">
          Experience seamless, borderless trading powered by global
          accessibility.
        </h5>

        <router-link
          v-if="$parent.isAuth"
          :to="{ name: 'BuyCrypto' }"
          class="button black get-started"
        >
          Get started
        </router-link>
        <button
          v-else
          @click="$parent.openSignInModal"
          class="button black get-started"
        >
          Get started
        </button>
      </div>
      <img class="figure" src="../images/figure_2.svg" alt="" />
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  props: ["staticPages"],
  data: function () {
    return {};
  },
  computed: {
    aboutUs() {
      return this.staticPages.find(({ title }) => title === "About Us");
    },
  },
  methods: {},
};
</script>
